import React from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'

import { Box, Flex, Image } from '@chatterbug/aaron'

const ListItemInfo = React.memo(
  ({ iconUrl, iconShape, iconSx, name, renderFooter, tooltip }) => {
    return (
      <Flex alignItems="center" flex="1">
        {iconUrl && (
          <Image
            src={iconUrl}
            alt={name}
            sx={iconSx}
            borderRadius={iconShape === 'rounded' ? 'full' : 'none'}
          />
        )}
        <Flex
          flexDirection="column"
          flex={{ _: '1', tablet: 'none' }}
          data-tip={tooltip}
          data-for={`tooltip-${name}`}
        >
          <Box variant="text.h4">{name}</Box>
          {renderFooter}
        </Flex>
        {tooltip && (
          <ReactTooltip
            id={`tooltip-${name}`}
            place="bottom"
            className="react-tooltip-small"
          />
        )}
      </Flex>
    )
  }
)

ListItemInfo.propTypes = {
  iconUrl: PropTypes.string,
  iconShape: PropTypes.oneOf(['rounded']),
  iconSx: PropTypes.object,
  name: PropTypes.string.isRequired,
  renderFooter: PropTypes.any,
  tooltip: PropTypes.string,
}

export default ListItemInfo
